import { initialsOf } from '../../../util/initials'

const Avatar = ({ name, isYou }: { name: string; isYou: boolean }) => (
  <div
    className={`h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${
      isYou ? 'bg-green-700 text-paper' : 'bg-green-100 text-green-800'
    }`}
  >
    {initialsOf(name)}
  </div>
)

export default Avatar
